import axiosInstance from "../api/axios";
import { FormData } from "../types/contact";

export const createContact = async (data: FormData) => {
  try {
    const response = await axiosInstance.post(`/contact/`, data);
    return {
      success: true,
      data: response.data,
    };
  } catch (error: any) {
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Something went wrong",
    };
  }
};
